<template>
  <el-dialog
    :title="'选择物料出库信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    height="600px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
      ><el-tabs v-model="activeName">
        <el-tab-pane label="物料信息" name="first">
          <el-row :gutter="10">
            <!-- <el-col style="text-align:center; font-size:larger; font-weight:bold; " :span="24">合计： {{ this.weighcount }}{{ this.unit }}</el-col> -->
            <!-- <el-divider content-position="left">物料销售</el-divider> -->
            <el-col :span="8">
              <el-form-item label="计划销售" prop="TQuantity">
                <el-input-number
                  v-model="form.TQuantity"
                  @change="handleChange"
                  :min="0"
                  :max="this.weighcount"
                  placeholder="计划销售"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实际销售" prop="SalesWeigh">
                <el-input
                  v-model="form.SalesWeigh"
                  placeholder="计划销售"
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料单价" prop="SalesPrice">
                <el-input
                  v-model.trim="form.SalesPrice"
                  :placeholder="'单价(' + this.unit + ')'"
                  :rules="[this.$g.validRequired, this.$g.validFloat2]"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 数据列表 -->
          <el-divider content-position="left">物料来源</el-divider>
          <template>
            <div style="height: 400px; overflow: auto">
              <el-table
                :data="data"
                ref="table"
                highlight-current-row
                @selection-change="selectionChange"
                @current-change="handleCurrentChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <!-- <el-table-column
            label="仓库编号"
            prop="WarehouseId"
            width="180"
            show-overflow-tooltip
          ></el-table-column> -->

                <el-table-column
                  label="物料名称"
                  prop="MaterialName"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="仓库名称"
                  prop="WarehouseName"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="入场编号"
                  prop="Source"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="总重量"
                  prop="Weight"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  label="单位"
                  prop="Unit"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </div>
            <el-pagination
              ref="breadCrumb"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 50, 100]"
              @size-change="getTableData(1)"
              @current-change="getTableData()"
              :current-page.sync="pageIndex"
              :page-size.sync="pageSize"
              :total="pageTotal"
            ></el-pagination>
          </template>
        </el-tab-pane>
        <el-tab-pane label="商品信息" name="second">
          <el-row :gutter="10">
            <!-- <el-col style="text-align:center; font-size:larger; font-weight:bold; " :span="24">合计： {{ this.weighcount }}{{ this.unit }}</el-col> -->
            <!-- <el-divider content-position="left">物料销售</el-divider> -->
            <el-col :span="24">
              <el-form-item label="商品详情" prop="ShopDetail">
                <div id="summernote"></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="FromElRowMargin">
            <!-- <el-col style="text-align:center; font-size:larger; font-weight:bold; " :span="24">合计： {{ this.weighcount }}{{ this.unit }}</el-col> -->
            <!-- <el-divider content-position="left">物料销售</el-divider> -->
            <el-col :span="12">
              <el-form-item label="商品缩略图">
                <UploadPhoto
                  type="shopimg"
                  url:="defaultUrl"
                  @success="
                    (r) => {
                      this.form.ShopPhoto = r;
                    }
                  "
                  label="商品缩略图"
                ></UploadPhoto>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品展示图">
                <UploadPhoto
                  type="shopimg"
                  url:="defaultUrl2"
                  @success="
                    (r) => {
                      this.form.ShopDetailPhoto = r;
                    }
                  "
                  label="商品缩略图"
                ></UploadPhoto>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!-- <el-col style="text-align:center; font-size:larger; font-weight:bold; " :span="24">合计： {{ this.weighcount }}{{ this.unit }}</el-col> -->
            <!-- <el-divider content-position="left">物料销售</el-divider> -->
            <el-col :span="24">
              <el-form-item label="备注" prop="ShopRemark">
                <el-input v-model="form.ShopRemark" placeholder="包邮"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >确认销售</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
import $ from "jquery";
window.jQuery = $;
window.$ = $;

import "bootstrap";
import "bootstrap/js/modal.js";
import "bootstrap/js/dropdown.js";
import "bootstrap/js/tooltip.js";
import "bootstrap/dist/css/bootstrap.css";
// 导入popper.js，popper.js是bootstrap下的一个特效
import "font-awesome/css/font-awesome.css";
import "summernote";
import "summernote/dist/lang/summernote-zh-CN.js";
import "summernote/dist/summernote.css";
import UploadPhoto from "../../components/UploadPhoto.vue";
export default {
  props: ["item"],
  components: {
    UploadPhoto,
  },
  data() {
    return {
      activeName: "first",
      ShopDetailPhoto: "",
      ShopPhoto: "",
      defaultUrl: "",
      defaultUrl2: "",
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      WarehouseId: "",
      WarehouseName: "",
      ShopDetail: "",
      ShopRemark: "",
      ScrapId: "",
      ScrapName: "",
      selectdata: [],
      EntyId: [],
      data: [],
      weighcount: 0,
      unit: "",
      rules: {
        SalesWeigh: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        SalesPrice: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.weighcount = 0;
        this.defaultUrl = "";
        this.defaultUrl2 = "";
        this.WarehouseId = v.WarehouseId;
        this.WarehouseName = v.WarehouseName;
        this.ScrapId = v.ScrapId;
        this.ScrapName = v.ScrapName;
        this.activeName = "first";
        this.ShopDetail = "";
        this.ShopDetailPhoto = "";
        this.ShopPhoto = "";
        this.ShopRemark = "";
        this.$set(this.form, "SalesPrice", "");
        this.$set(this.form, "SalesWeigh", "");
        this.$set(this.form, "TQuantity", "");
        this.$get("MaterialSalesRecords/GetMaterialExitRecords", {
          WarehouseId: v.WarehouseId,
          ScrapId: v.ScrapId,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        }).then((r) => {
          let list = r.Result;
          let pageTotal = r.Rows;
          if (list.length > 0) {
            let row = list[0];
            this.$refs.table.setCurrentRow(row);
            //单位

            this.unit = row.Unit;
            //计算总金额
            list.forEach((it) => {
              this.weighcount += it.Weight;
            });
          }

          this.data = list;
          this.pageTotal = pageTotal;
        });
      },
    },
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.summernote();
        });
      }
    },
  },
  methods: {
    summernote() {
      // 先检查元素是否存在
      if ($("#summernote").length === 0) {
        console.error("Summernote container not found");
        return;
      }

      $("#summernote").summernote({
        lang: "zh-CN",
        height: 350,
        minHeight: null,
        maxHeight: null,
        focus: true,
      });
    },
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    //保存
    save() {
      // 获取summernote输入的值的方法 $('#summernote2').summernote('code')

      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        var contant = $("#summernote").summernote("code");
        this.$confirm(
          `你将出库选中的物料，确认出库后数据将无法恢复, 是否继续?`,
          "提示信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "el-button--canale",
            type: "warning",
          }
        )
          .then(() => {
            //获取选中的ID
            this.EntyId = [];
            this.selectdata.forEach((row) => {
              this.EntyId.push(row.EntryId);
            });
            this.$post("MaterialSalesRecords/MaterialSalesRecords", {
              WarehouseId: this.WarehouseId,
              WarehouseName: this.WarehouseName,
              ScrapId: this.ScrapId,
              ScrapName: this.ScrapName,
              SalesWeigh: this.form.SalesWeigh,
              SalesPrice: this.form.SalesPrice,
              EntryId: this.EntyId,
              ShopDetail: contant,
              ShopRemark: this.ShopRemark,
              ShopPhoto: this.ShopPhoto,
              ShopDetailPhoto: this.ShopDetailPhoto,
            }).then(() => {
              this.$message.success("出库成功");
              this.$emit("success");
              this.$refs.list.getTableData();
            });
            this.visible = false;
          })
          .catch(() => {
            this.visible = false;
          });
      });
    },
    //复选框
    selectionChange(selection) {
      this.selectdata = selection;
      let count = 0;
      selection.forEach((it) => {
        count = it.Weight + count;
      });
      this.$set(this.form, "SalesWeigh", count);
    },
    //选中行
    handleCurrentChange(row) {
      this.$emit("currentrow", row);
    },
    //计数器
    handleChange(values) {
      this.$refs.table.clearSelection();
      if (values > 0) {
        for (let i = 0; i < this.data.length; i++) {
          let it = this.data[i];
          if (it.Weight >= values) {
            this.$refs.table.toggleRowSelection(it, true);
            break;
          } else {
            this.$refs.table.toggleRowSelection(it, true);
            values -= it.Weight;
          }
        }
      }
    },
    getTableData(pageIndex) {
      var parm = { ...this.filter };
      if (parm.selectedDate) {
        parm.selectedDate = JSON.stringify(parm.selectedDate);
      }

      if (pageIndex) {
        this.pageIndex = pageIndex;
      }
      this.$get(this.url, {
        WarehouseId: this.WarehouseId,
        ScrapId: this.ScrapId,
        PageNumber: this.pageIndex,
        PageSize: this.pageSize,
      }).then((r) => {
        let list = r.Result;
        let pageTotal = r.Rows;
        if (list.length > 0) {
          let row = list[0];
          this.$refs.table.setCurrentRow(row);
        }
        this.data = list;
        this.pageTotal = pageTotal;
      });
    },
    getTableData(pageIndex) {
      // var parm = { ...this.filter };
      // if (parm.selectedDate) {
      //   parm.selectedDate = JSON.stringify(parm.selectedDate);
      // }

      if (pageIndex) {
        this.pageIndex = pageIndex;
      }
      this.$get("MaterialSalesRecords/GetMaterialExitRecords", {
        WarehouseId: this.WarehouseId,
        ScrapId: this.ScrapId,
        PageNumber: this.pageIndex,
        PageSize: this.pageSize,
      }).then((r) => {
        let list = r.Result;
        let pageTotal = r.Rows;
        if (list.length > 0) {
          let row = list[0];
          this.$refs.table.setCurrentRow(row);
        }
        this.data = list;
        this.pageTotal = pageTotal;
      });
    },
  },
};
</script>    
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}

#summernote {
  display: block;
  width: 100%;
  height: 100px;
  border: 1px solid #e6e6e6;
  margin-bottom: 15px;
}

.RLayoutBox {
  height: calc(100vh - 114px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.FromSearchMargin {
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
</style>